import React from 'react';
import { Rocket, Brain, BarChart3, Shield } from 'lucide-react';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: Brain,
      title: 'Creativity + Technology',
      description: 'We unite creative excellence with advanced technology to deliver solutions that are both beautiful and powerful.'
    },
    {
      icon: Rocket,
      title: 'Scalability First',
      description: 'Every solution we build is designed to grow with your business, ensuring long-term success and adaptability.'
    },
    {
      icon: BarChart3,
      title: 'Measurable Results',
      description: 'We focus on data-driven strategies that deliver tangible, measurable outcomes for your business.'
    },
    {
      icon: Shield,
      title: 'End-to-End Support',
      description: 'From initial strategy to global expansion, we provide comprehensive support at every stage of your journey.'
    }
  ];

  return (
    <section id="why-choose" className="why-choose-section">
      <div className="why-choose-container">
        <div className="why-choose-header">
          <span className="section-label">Why Choose Us</span>
          <h2 className="section-title">We Don't Just Build Brands — We Engineer Ecosystems</h2>
          <p className="section-description">
            Our approach unites creativity with advanced technology, enabling clients to operate
            efficiently, scale confidently, and stand out globally.
          </p>
        </div>

        <div className="why-choose-grid">
          {reasons.map((reason, index) => {
            const IconComponent = reason.icon;
            return (
              <div key={index} className="why-choose-card">
                <div className="why-choose-icon-wrapper">
                  <IconComponent className="why-choose-icon" size={32} />
                </div>
                <h3 className="why-choose-card-title">{reason.title}</h3>
                <p className="why-choose-card-description">{reason.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;